import { prepareModel, extractItems } from './infrastructure.model-helpers';
import dirtyItems from '../../../scripts/enums/infrastructure';
import { splitItemsToColumns } from '../../../scripts/utils/splitItemsToColumns';

const itemsContext = require.context('../../../scripts/enums/infrastructure/');

export default [
  '$scope',
  '$rootScope',
  'categoryService',
  'deviceService',
  function ($scope, $rootScope, categoryService, deviceService) {
    this.ad.building = this.ad.building || {};
    this.ad.building.infrastructure = this.ad.building.infrastructure || {};
    this.itemsColumns = [];
    let items = prepareModel(dirtyItems, this);

    const columnsCount = deviceService.isMobile ? 2 : 4;
    const splitItems = splitItemsToColumns(columnsCount);

    const setItems = category => {
      const { objectType } = categoryService.getInfoByCategory(category);
      const extractedItems = extractItems(objectType, items, itemsContext);
      this.itemsColumns = splitItems(extractedItems);
      this.setSegmentVisible({
        segment: 'infrastructure',
        value: this.itemsColumns.some(item => Boolean(item.length)),
      });
    };

    $scope.$watch(
      () => this.ad.category,
      category => {
        if (category) {
          setItems(category);
        }
      },
    );

    // Обновить чекбоксы при смене инфраструктуры (выбрали БЦ)
    $scope.$watch(
      () => this.ad.building.infrastructure,
      infrastructure => {
        if (infrastructure) {
          items = prepareModel(dirtyItems, this);
          setItems(this.ad.category);
        }
      },
    );
  },
];
